import Modal from "components/atom/Modal.tsx";
import Button from "components/atom/button/Button.tsx";
import designerPng from "assets/images/designer.png";
import { useTranslation } from "react-i18next";

function ConfirmActionModal(props: {
  isOpen: boolean,
  onClose: () => void,
  onAccept: () => void,
  children?: React.ReactNode
  showImage?: boolean
  showTitle?: boolean
  showCancelBtn?: boolean
  cancelLabel?: string
  acceptLabel?: string
}) {
  const {
    onClose,
    onAccept,
    isOpen,
    children,
    showTitle = true,
    showImage = true,
    showCancelBtn = true,
    cancelLabel,
    acceptLabel
  } = props;
  const { t } = useTranslation();
  if (!isOpen) {
    return null;
  }

  return (
    <Modal flexibleHeight className="plan-changed" onClose={onClose}>
      <div className="w-full">
        {showImage && (
          <img src={designerPng} className="mx-auto block h-[200px] w-auto" />
        )}
        {showTitle && (
          <h2 className="text-2xl pb-3 text-center font-semibold">
            {t("popup.confirmAction.title")}
          </h2>
        )}
        <div className="pb-12 text-center text-gray-400">
          {children}
        </div>

        <div className="flex flex-row justify-center items-center gap-4">
          {showCancelBtn && (
            <Button style="red" className="block w-full" onClick={onClose}>
              {cancelLabel ? cancelLabel : t("cancel")}
            </Button>
          )}
          <Button className="block w-full" onClick={onAccept}>
            {acceptLabel ? acceptLabel : t("continue")}
          </Button>
        </div>

      </div>
    </Modal>
  );
}


export default ConfirmActionModal;
